<script>
import GraphqlEditableTable from '@/components/GraphqlEditableTable'
import McEmptyState from '@/components/McEmptyState'

const defaultFieldOpts = {
  editable: true,
  isSortable: true,
}

export default {
  components: {
    GraphqlEditableTable,
    McEmptyState,
  },
  props: {
    status: String,
  },
  data() {
    return {
      isTableDataAvailable: true,
      apiClient: {
        get: 'GET_ADDRESS_CATEGORIES',
        update: 'UPDATE_ADDRESS_CATEGORIES',
        store: 'CREATE_ADDRESS_CATEGORIES',
        delete: 'DELETE_ADDRESS_CATEGORIES',
      },
      fields: [
        {
          ...defaultFieldOpts,
          key: 'text',
          label: this.$t('setting.list.generalSetting.kategoriAlamat'),
          sortable: true,
          placeholder: this.$t('setting.list.generalSetting.kategoriAlamat'),
          validation: 'required|max:64,length',
          error: null,
          type: 'text',
          'validation-messages': {
            required: 'Wajib diisi',
            max: 'Nama kategori alamat tidak lebih dari 64 karakter',
          },
        },
      ],
    }
  },

  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    setStatus() {
      this.$store.commit('setting/SET_STATUS', this.status)
    },
  },
}
</script>

<template>
  <!-- Kategori Alamat -->
  <b-tab class="border-0" @click="setStatus">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('setting.list.generalSetting.kategoriAlamat') }}</span>
    </template>
    <GraphqlEditableTable
      v-show="isTableDataAvailable"
      ref="table"
      searchable
      :fields="fields"
      :apiClient="apiClient"
      @available-change="handleDataAvailable"
    />
    <div v-show="!isTableDataAvailable" class="empty-table-container">
      <McEmptyState
        :title="$t('setting.list.generalSetting.emptyKategoriAlamat')"
        :desc="$t('global.addNewData')"
        :buttonText="$t('global.addField')"
        @buttonPrimaryAction="handleAdd"
      />
    </div>
  </b-tab>
</template>
